import styled from 'styled-components'

const LeaveGuildContainer = styled.div`
`

export default LeaveGuildContainer
